module.exports = __webpack_public_path__ + "img/album16_09.78b2ee21.jpg";